/* Mechanical nt2 feature parity. Hyper owns styling and rnMeasure owns analytics. */
(function () {
  'use strict';
  if (window.__rnProductSmallFeatures) return;
  window.__rnProductSmallFeatures = true;

  function hintEvent(el, method) {
    if (typeof window.rnMeasure === 'function') {
      window.rnMeasure('rn_hint_share', { module_id: 'drop_a_hint', cta_label: method, rn_product_id: 'gid://shopify/Product/' + el.dataset.id });
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rn-hint-open],[data-rn-hint-method]');
    if (!button) return;
    var el = button.closest('[data-rn-drop-hint]');
    if (!el) return;
    if (button.hasAttribute('data-rn-hint-open')) {
      if (window.matchMedia('(pointer:coarse)').matches && navigator.share) {
        navigator.share({ title: el.dataset.text, text: el.dataset.text, url: el.dataset.url })
          .then(function () { hintEvent(el, 'share_sheet'); }).catch(function () {});
        return;
      }
      var row = el.querySelector('[data-rn-hint-row]');
      row.hidden = !row.hidden;
      button.setAttribute('aria-expanded', String(!row.hidden));
      if (!row.hidden) hintEvent(el, 'open');
      return;
    }
    var method = button.dataset.rnHintMethod;
    hintEvent(el, method);
    if (method === 'copy') {
      var fallback = function () { window.prompt('Copy this link', el.dataset.url); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(el.dataset.url).then(function () { button.textContent = 'Link copied'; }, fallback);
      } else fallback();
    }
  });

  function inches(cm) {
    var value = parseFloat(cm) / 2.54;
    return String(value >= 10 ? Math.round(value) : Math.round(value * 10) / 10);
  }
  function convert(text, bare) {
    // Never add a second imperial annotation or reinterpret weights, capacity or product input values.
    if (/\b(?:in|inch|inches)\b/i.test(text)) return text;
    if (bare && /^\s*\d+(?:\.\d+)?(?:\s*[x×]\s*\d+(?:\.\d+)?)*\s*$/.test(text)) text += ' cm';
    return text.replace(/(\d+(?:\.\d+)?(?:\s*(?:[x×]|to|[-–])\s*\d+(?:\.\d+)?)*)\s*cm\b/g, function (match, numbers) {
      return match + ' (' + numbers.replace(/\d+(?:\.\d+)?/g, inches) + '\u00a0in)';
    });
  }
  function applyUnits(product) {
    if (product.dataset.rnSizeCountry !== 'US') return;
    var scopes = product.querySelectorAll('.rn-pdp__facts,.rn-pdp__kf,[data-rn-product-content],.rn-product-decision-facts,[data-rn-size-option]');
    scopes.forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style,textarea,input,button[data-rn-hint-method],.visually-hidden')) continue;
        var bare = product.dataset.rnSizeCm === 'true' && !!node.parentElement.closest('[data-rn-size-option]');
        var next = convert(node.nodeValue, bare);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  }
  function init() {
    document.querySelectorAll('product-info[data-rn-size-country]').forEach(function (product) {
      if (product.__rnUnits) return;
      product.__rnUnits = true;
      applyUnits(product);
      new MutationObserver(function () { applyUnits(product); }).observe(product, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
